import moment from "moment";

export const defaultTrialFinishDate = moment().add(14, "days").toDate();

export const endOfDay = (date?: Date) =>
  date ? moment(date).endOf("day").toDate() : date;
